import apiClient from "../apiClient";
import { apiBaseUrl } from "../../config";

export const getServices = async ({
  page = 1,
  limit = 10,
  search = "",
  filters = "",
}) => {
  return apiClient
    .get(
      `${apiBaseUrl}/catalogs/services?limit=${limit}&page=${page}&q=wildCard~${search}${filters}`,
      {}
    )
    .then((response) => {
      return response;
    });
};

export const createService = async (data) => {
  return apiClient
    .post(`${apiBaseUrl}/catalogs/services`, data)
    .then((response) => {
      return response;
    });
};

export const updateService = async (serviceId, data) => {
  return apiClient
    .put(`${apiBaseUrl}/catalogs/services/${serviceId}`, data)
    .then((response) => {
      return response;
    });
};
